import { render } from "./AccessoriesSection.vue?vue&type=template&id=083f8439&scoped=true"
import script from "./AccessoriesSection.vue?vue&type=script&lang=js"
export * from "./AccessoriesSection.vue?vue&type=script&lang=js"

import "./AccessoriesSection.vue?vue&type=style&index=0&id=083f8439&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083f8439"]])

export default __exports__